import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import ScrollToTop from '@/components/ScrollToTop';
import SocialFloatingButtons from '@/components/SocialFloatingButtons';

const PublicLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-white">
      <ScrollToTop />
      <Header />
      <main>
        {children}
      </main>
      <Footer />
      <SocialFloatingButtons />
    </div>
  );
};

export default PublicLayout;
